import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Td,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const ServicesCard = ({
  id,
  serviceName,
  serviceCode,
  price,
  OpenBlockModal,
  themeColor,
  borderColor,
  textColor,
  subTextColor,
  server
}) => {
  // const { isOpen, onOpen,  NewClose=onClose } = useDisclosure();
  return (
    <>
      <Tr>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor} color={textColor}>{serviceName}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor} color={textColor}>{serviceCode}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor} color={textColor}>{server}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor} color={textColor}>{price}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor}>
          <Button
            _hover={{
              bg: "teal.600",
              color: "white",
            }}
            color={themeColor}
            bg={"transparent"}
            w={"75%"}
            h={"2.35rem"}
            p={0}
            fontSize={"0.97rem"}
            border={"1px solid"}
            borderColor={themeColor}
            onClick={() => OpenBlockModal(id, "edit", { serviceName, serviceCode, price })}
          >
            Edit
          </Button>
        </Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottomWidth="1px" borderColor={borderColor}>
          {/* <Text>Block</Text> */}
          <Button
            _hover={{
              bg: "red.600",
              color: "white",
            }}
            color={"red.500"}
            bg={"transparent"}
            w={"75%"}
            h={"2.35rem"}
            p={0}
            fontSize={"0.97rem"}
            border={"1px solid"}
            borderColor={"red.500"}
            onClick={() => OpenBlockModal(id, "delete")}
          >
            Delete
          </Button>
        </Td>
      </Tr>
    </>
  );
};

export default ServicesCard;
